import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { Card } from './card.model';
import { DateUtils } from 'ng-jhipster';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';
@Injectable()
export class CardService  extends AbstractEntityService {

    protected resourceUrl = 'api/cards';
    private resourceSearchUrl = 'api/_search/cards';
    private resourceSearchStatsUrl = 'api/_search/stats/cards';
    protected resourceCountUrl = 'api/_search/count/cards';

    constructor(protected http: HttpClient, private dateUtils: DateUtils) { super(http); }

    create(card: Card): Observable<Card> {
        let copy: Card = Object.assign({}, card);
        copy.validUntil = this.dateUtils
            .convertLocalDateToServer(card.validUntil);
        copy.validSince = this.dateUtils
            .convertLocalDateToServer(card.validSince);
        return this.http.post<Card>(this.resourceUrl, copy).map((res: Card) => {
            return res;
        });
    }

    update(card: Card): Observable<Card> {
        let copy: Card = Object.assign({}, card);
        copy.validUntil = this.dateUtils
            .convertLocalDateToServer(card.validUntil);
        copy.validSince = this.dateUtils
            .convertLocalDateToServer(card.validSince);
        return this.http.put<Card>(this.resourceUrl, copy).map((res: Card) => {
            return res;
        });
    }

    find(id: number): Observable<Card> {
        return this.http.get<Card>(`${this.resourceUrl}/${id}`).map((res: Card) => {
            let jsonResponse = res;
            jsonResponse.validUntil = this.dateUtils
                .convertLocalDateFromServer(jsonResponse.validUntil);
            jsonResponse.validSince = this.dateUtils
                .convertLocalDateFromServer(jsonResponse.validSince);
            return jsonResponse;
        });
    }

    query(req?: any): Observable<HttpResponse<Card[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<Card[]>>(this.resourceUrl, options)
            .map((res: HttpResponse<Card[]>) => this.convertResponse(res))
            ;
    }

    search(req?: any): Observable<HttpResponse<Card[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<Card[]>>(this.resourceSearchUrl, options)
            .map((res: HttpResponse<Card[]>) => this.convertResponse(res));
    }

    searchStats(req?: any): Observable<HttpResponse<any>> {
        let options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchStatsUrl, options)
            .map((res: any) => this.convertResponse(res));
    }

    getAvailableAssistances(card: Card): number {
        if (card) {
            if (card.maxAssistancesNum) {
                const availableBookings = card.maxAssistancesNum - card.usedReservations;
                return availableBookings > 0 ? availableBookings : 0;
            }
        }

        return 0;
    }

    private convertResponse(res: HttpResponse<Card[]>): any {
        let jsonResponse = res.body;
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].validUntil = this.dateUtils
                .convertLocalDateFromServer(jsonResponse[i].validUntil);
            jsonResponse[i].validSince = this.dateUtils
                .convertLocalDateFromServer(jsonResponse[i].validSince);
        }
        return res.clone({body: jsonResponse});
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/card/card.service.ts